import { useCallback, useEffect } from 'react';
export default function useBodyClick({ ref, handler, }) {
    const handleBodyClick = useCallback(e => {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && handler && !ref.current.contains(e.target)) {
            handler(e);
        }
    }, [ref, handler]);
    useEffect(() => {
        document.addEventListener('click', handleBodyClick);
        document.addEventListener('contextmenu', handleBodyClick);
        return () => {
            document.removeEventListener('click', handleBodyClick);
            document.removeEventListener('contextmenu', handleBodyClick);
        };
    }, [handleBodyClick]);
}
